module.exports = __webpack_public_path__ + "img/home-top-bubble-2.4f608888.svg";